import React from 'react';
import { CUMBRE_RUTA } from '../constants/cumbreRuta';

function milestoneClassName(emphasis?: 'next' | 'finale') {
  if (!emphasis) return 'cumbre-ruta__item';
  return `cumbre-ruta__item cumbre-ruta__item--${emphasis}`;
}

const CumbreRuta: React.FC = () => {
  return (
    <ol className="cumbre-ruta" aria-label="Hitos de la ruta nacional">
      {CUMBRE_RUTA.map((item, index) => (
        <li key={item.title} className={milestoneClassName(item.emphasis)}>
          <span className="cumbre-ruta__index" aria-hidden="true">
            {String(index + 1).padStart(2, '0')}
          </span>
          <div>
            <h3 className="cumbre-ruta__name">{item.title}</h3>
            <p className="cumbre-ruta__body">{item.body}</p>
            {item.note && <p className="cumbre-ruta__note">{item.note}</p>}
          </div>
        </li>
      ))}
    </ol>
  );
};

export default CumbreRuta;
